// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-campaign-title {
  background-color: #F7FAFC;
  font-size: 14px;
  font-weight: bold;
  color: #142B31;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  border-bottom: 1px solid #D3E1ED;
}
.view-campaign-title .view-campaign-buttons {
  display: flex;
  column-gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Campaigns/ViewCampaign/ViewCampaign.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AACD;AACC;EACC,aAAA;EACA,gBAAA;AACF","sourcesContent":[".view-campaign-title {\n\tbackground-color: #F7FAFC;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: #142B31;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 20px 30px;\n\tborder-bottom: 1px solid #D3E1ED;\n\n\t.view-campaign-buttons {\n\t\tdisplay: flex;\n\t\tcolumn-gap: 10px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
